import { writable } from 'svelte/store';

const HeroDealsStore = writable();

export default HeroDealsStore;
